/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Aktion { 
    aktion_id: string;
    titel: string;
    info_text: string;
    reihenfolge?: number;
    veranstaltung_id: string;
    mandant_id?: string;
    modified_on_utc?: Date;
}

